'use client';

import React, { useState, createContext, ReactNode, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/shared/shadcn/ui/dialog';

interface DialogData {
  content: ReactNode;
  title?: string;
  description?: string;
}

interface DialogContextType {
  showDialog: (data: DialogData) => void;
  hideDialog: () => void;
}

export const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [dialogData, setDialogData] = useState<DialogData | null>(null);

  const showDialog = useCallback((data: DialogData) => {
    setDialogData(data);
  }, []);

  const hideDialog = useCallback(() => {
    setDialogData(null);
  }, []);

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      hideDialog();
    }
  };

  return (
    <DialogContext.Provider value={{ showDialog, hideDialog }}>
      {children}
      <Dialog open={!!dialogData} onOpenChange={handleOpenChange}>
        <DialogContent className="max-h-[calc(100vh-4rem)] overflow-scroll">
          {(dialogData?.title ?? dialogData?.description) && (
            <DialogHeader className="mb-4">
              {dialogData.title && <DialogTitle>{dialogData.title}</DialogTitle>}
              {dialogData.description && <DialogDescription>{dialogData.description}</DialogDescription>}
            </DialogHeader>
          )}
          {dialogData?.content}
        </DialogContent>
      </Dialog>
    </DialogContext.Provider>
  );
};
